export const Channels = {
  EXCEL: 'excel',
  BULK: 'bulk',
};
